import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { StoreIdService } from '../services/store-id.service';
import { AcceptHeader } from './accept-header.enum';
import { PASS_ACCEPT_HEADER } from './accept-header.context';

// Intercepts ALL http requests made with HttpClient and to the CWO API 
// and adds headers that are required by the API
// Other global headers can be added here
export const globalRequestHeadersInterceptor: HttpInterceptorFn = (req, next) => { 
  const storeId = inject(StoreIdService);
  // All CWO API endpoints are prefixed with /ws (at least at the time of writing this)
  // If the request isn't going to the API then we shouldn't pass the headers
  if (!req.url.includes('/ws')) {
    return next(req);
  }

  const headers: any = {};
  // These are the headers that the API requires in every call
  // NOTE: Angular automatically adds the XSRF-TOKEN header if the server provides it (CWO does).
  // See https://angular.io/guide/http-security-xsrf-protection for more details
  headers['X-Requested-With'] = 'XMLHttpRequest'; // See : https://stackoverflow.com/questions/17478731/whats-the-point-of-the-x-requested-with-header
  headers['x-fts-client'] = 'latte'; // TODO: Remove this when the API stops requiring it.
  headers['x-fts-store'] = storeId.storeId;

  const passAcceptHeader = req.context.get(PASS_ACCEPT_HEADER);  
  if(passAcceptHeader) headers['Accept']= req.headers.get('Accept') === AcceptHeader.HATEOAS ? AcceptHeader.HATEOAS : AcceptHeader.Plain;

  // Set the above headers in a request object clone, and forward it to the browser
  return next(
    req.clone({
      setHeaders: headers
    })
  );
};
